import { ActiveMockService } from "../@types/mock.js";
function getListMock() {
  try {
    const list = localStorage.getItem(ActiveMockService.list);
    return JSON.parse(list || "{}");
  } catch {
    return {};
  }
}
function getIsActive() {
  try {
    const list = localStorage.getItem(ActiveMockService.isActive);
    return !!list;
  } catch {
    return false;
  }
}
function setActiveMock() {
  localStorage.setItem(ActiveMockService.isActive, "true");
}
function addListMock(listMock) {
  localStorage.setItem(ActiveMockService.list, JSON.stringify(listMock));
}
function clear() {
  localStorage.removeItem(ActiveMockService.isActive);
  localStorage.removeItem(ActiveMockService.list);
}
export {
  addListMock,
  clear,
  getIsActive,
  getListMock,
  setActiveMock
};
//# sourceMappingURL=service.js.map
